// src/redux/store.js
import { legacy_createStore } from "redux";
import rootReducer from "./reducers";

const store = legacy_createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // For Redux DevTools
);

export default store;
